export const malwareData=[
  {
    "scanId": "MA4429FE57",
    "category": "Malware Scan",
    "assetname": "Node.js",
    "resolved": false,
    "fileName": "node-v22.12.0-x64.msi",
    "filePath": "C:\\Users\\UT\\bluhawk\\VulnerabilityBackend\\data\\demo\\malware\\files\\node-v22.12.0-x64.msi",
    "analysisNotes": "Node.js Executable Malware Analysis",
    "timestamp": "04 January 2025",
    "status": "Completed",
    "analysisId": "MTA2MTY3ZDU1ZTBiYmZjN2UyNDI4ZjlhYWMxZWY2ODg6MTczNTk3Mzk5OA==",
    "analysisReport": {
      "Lionic": {
        "method": "blacklist",
        "engine_name": "Lionic",
        "engine_version": "8.16",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "MicroWorld-eScan": {
        "method": "blacklist",
        "engine_name": "MicroWorld-eScan",
        "engine_version": "14.0.409.0",
        "engine_update": "20250101",
        "category": "undetected",
        "result": null
      },
      "ClamAV": {
        "method": "blacklist",
        "engine_name": "ClamAV",
        "engine_version": "1.4.1.0",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "CMC": {
        "method": "blacklist",
        "engine_name": "CMC",
        "engine_version": "2.4.2022.1",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "CAT-QuickHeal": {
        "method": "blacklist",
        "engine_name": "CAT-QuickHeal",
        "engine_version": "22.00",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Skyhigh": {
        "method": "blacklist",
        "engine_name": "Skyhigh",
        "engine_version": "v2021.2.0+4045",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "ALYac": {
        "method": "blacklist",
        "engine_name": "ALYac",
        "engine_version": "2.0.0.10",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Malwarebytes": {
        "method": "blacklist",
        "engine_name": "Malwarebytes",
        "engine_version": "4.5.5.54",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Zillya": {
        "method": "blacklist",
        "engine_name": "Zillya",
        "engine_version": "2.0.0.5271",
        "engine_update": "20250102",
        "category": "undetected",
        "result": null
      },
      "Sangfor": {
        "method": "blacklist",
        "engine_name": "Sangfor",
        "engine_version": "2.22.3.0",
        "engine_update": "20241231",
        "category": "undetected",
        "result": null
      },
      "CrowdStrike": {
        "method": "blacklist",
        "engine_name": "CrowdStrike",
        "engine_version": "1.0",
        "engine_update": "20230417",
        "category": "undetected",
        "result": null
      },
      "K7GW": {
        "method": "blacklist",
        "engine_name": "K7GW",
        "engine_version": "12.209.54383",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "K7AntiVirus": {
        "method": "blacklist",
        "engine_name": "K7AntiVirus",
        "engine_version": "12.209.54383",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Baidu": {
        "method": "blacklist",
        "engine_name": "Baidu",
        "engine_version": "1.0.0.2",
        "engine_update": "20190318",
        "category": "undetected",
        "result": null
      },
      "VirIT": {
        "method": "blacklist",
        "engine_name": "VirIT",
        "engine_version": "9.5.863",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Symantec": {
        "method": "blacklist",
        "engine_name": "Symantec",
        "engine_version": "1.22.0.0",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "ESET-NOD32": {
        "method": "blacklist",
        "engine_name": "ESET-NOD32",
        "engine_version": "30493",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "TrendMicro-HouseCall": {
        "method": "blacklist",
        "engine_name": "TrendMicro-HouseCall",
        "engine_version": "10.0.0.1040",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Avast": {
        "method": "blacklist",
        "engine_name": "Avast",
        "engine_version": "23.9.8494.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Cynet": {
        "method": "blacklist",
        "engine_name": "Cynet",
        "engine_version": "4.0.3.4",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "GData": {
        "method": "blacklist",
        "engine_name": "GData",
        "engine_version": "A:25.39593B:27.38778",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Kaspersky": {
        "method": "blacklist",
        "engine_name": "Kaspersky",
        "engine_version": "22.0.1.28",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "BitDefender": {
        "method": "blacklist",
        "engine_name": "BitDefender",
        "engine_version": "7.2",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "NANO-Antivirus": {
        "method": "blacklist",
        "engine_name": "NANO-Antivirus",
        "engine_version": "1.0.146.25796",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "SUPERAntiSpyware": {
        "method": "blacklist",
        "engine_name": "SUPERAntiSpyware",
        "engine_version": "5.6.0.1032",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Rising": {
        "method": "blacklist",
        "engine_name": "Rising",
        "engine_version": "25.0.0.28",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Emsisoft": {
        "method": "blacklist",
        "engine_name": "Emsisoft",
        "engine_version": "2024.1.0.53752",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "F-Secure": {
        "method": "blacklist",
        "engine_name": "F-Secure",
        "engine_version": "18.10.1547.307",
        "engine_update": "20250102",
        "category": "undetected",
        "result": null
      },
      "DrWeb": {
        "method": "blacklist",
        "engine_name": "DrWeb",
        "engine_version": "7.0.65.5230",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "VIPRE": {
        "method": "blacklist",
        "engine_name": "VIPRE",
        "engine_version": "6.0.0.35",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "TrendMicro": {
        "method": "blacklist",
        "engine_name": "TrendMicro",
        "engine_version": "11.0.0.1006",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Trapmine": {
        "method": "blacklist",
        "engine_name": "Trapmine",
        "engine_version": "4.0.3.0",
        "engine_update": "20241202",
        "category": "undetected",
        "result": null
      },
      "CTX": {
        "method": "blacklist",
        "engine_name": "CTX",
        "engine_version": "2024.8.29.1",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Sophos": {
        "method": "blacklist",
        "engine_name": "Sophos",
        "engine_version": "2.5.5.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Ikarus": {
        "method": "blacklist",
        "engine_name": "Ikarus",
        "engine_version": "6.3.23.0",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "FireEye": {
        "method": "blacklist",
        "engine_name": "FireEye",
        "engine_version": "35.47.0.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Jiangmin": {
        "method": "blacklist",
        "engine_name": "Jiangmin",
        "engine_version": "16.0.100",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Avira": {
        "method": "blacklist",
        "engine_name": "Avira",
        "engine_version": "8.3.3.20",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Antiy-AVL": {
        "method": "blacklist",
        "engine_name": "Antiy-AVL",
        "engine_version": "3.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Kingsoft": {
        "method": "blacklist",
        "engine_name": "Kingsoft",
        "engine_version": "None",
        "engine_update": "20241227",
        "category": "undetected",
        "result": null
      },
      "Gridinsoft": {
        "method": "blacklist",
        "engine_name": "Gridinsoft",
        "engine_version": "1.0.202.174",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Xcitium": {
        "method": "blacklist",
        "engine_name": "Xcitium",
        "engine_version": "37354",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Arcabit": {
        "method": "blacklist",
        "engine_name": "Arcabit",
        "engine_version": "2022.0.0.18",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "ViRobot": {
        "method": "blacklist",
        "engine_name": "ViRobot",
        "engine_version": "2014.3.20.0",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Microsoft": {
        "method": "blacklist",
        "engine_name": "Microsoft",
        "engine_version": "1.1.24090.11",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Varist": {
        "method": "blacklist",
        "engine_name": "Varist",
        "engine_version": "6.6.1.3",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "AhnLab-V3": {
        "method": "blacklist",
        "engine_name": "AhnLab-V3",
        "engine_version": "3.26.2.10521",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Acronis": {
        "method": "blacklist",
        "engine_name": "Acronis",
        "engine_version": "1.2.0.121",
        "engine_update": "20240328",
        "category": "undetected",
        "result": null
      },
      "McAfee": {
        "method": "blacklist",
        "engine_name": "McAfee",
        "engine_version": "6.0.6.653",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "TACHYON": {
        "method": "blacklist",
        "engine_name": "TACHYON",
        "engine_version": "2025-01-04.01",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "VBA32": {
        "method": "blacklist",
        "engine_name": "VBA32",
        "engine_version": "5.3.1",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Zoner": {
        "method": "blacklist",
        "engine_name": "Zoner",
        "engine_version": "2.2.2.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Tencent": {
        "method": "blacklist",
        "engine_name": "Tencent",
        "engine_version": "1.0.0.1",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Yandex": {
        "method": "blacklist",
        "engine_name": "Yandex",
        "engine_version": "5.5.2.24",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "huorong": {
        "method": "blacklist",
        "engine_name": "huorong",
        "engine_version": "49f05f0:49f05f0:bd14887:bd14887",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "MaxSecure": {
        "method": "blacklist",
        "engine_name": "MaxSecure",
        "engine_version": "1.0.0.1",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "Fortinet": {
        "method": "blacklist",
        "engine_name": "Fortinet",
        "engine_version": "None",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "AVG": {
        "method": "blacklist",
        "engine_name": "AVG",
        "engine_version": "23.9.8494.0",
        "engine_update": "20250104",
        "category": "undetected",
        "result": null
      },
      "Panda": {
        "method": "blacklist",
        "engine_name": "Panda",
        "engine_version": "4.6.4.2",
        "engine_update": "20250103",
        "category": "undetected",
        "result": null
      },
      "alibabacloud": {
        "method": "blacklist",
        "engine_name": "alibabacloud",
        "engine_version": "2.2.0",
        "engine_update": "20241030",
        "category": "undetected",
        "result": null
      },
      "Bkav": {
        "method": "blacklist",
        "engine_name": "Bkav",
        "engine_version": "2.0.0.1",
        "engine_update": "20250103",
        "category": "failure",
        "result": null
      },
      "McAfeeD": {
        "method": "blacklist",
        "engine_name": "McAfeeD",
        "engine_version": "1.2.0.7977",
        "engine_update": "20250104",
        "category": "type-unsupported",
        "result": null
      },
      "Avast-Mobile": {
        "method": "blacklist",
        "engine_name": "Avast-Mobile",
        "engine_version": "250103-00",
        "engine_update": "20250103",
        "category": "type-unsupported",
        "result": null
      },
      "BitDefenderFalx": {
        "method": "blacklist",
        "engine_name": "BitDefenderFalx",
        "engine_version": "2.0.936",
        "engine_update": "20241203",
        "category": "type-unsupported",
        "result": null
      },
      "Elastic": {
        "method": "blacklist",
        "engine_name": "Elastic",
        "engine_version": "4.0.181",
        "engine_update": "20241212",
        "category": "type-unsupported",
        "result": null
      },
      "DeepInstinct": {
        "method": "blacklist",
        "engine_name": "DeepInstinct",
        "engine_version": "5.0.0.8",
        "engine_update": "20250101",
        "category": "type-unsupported",
        "result": null
      },
      "APEX": {
        "method": "blacklist",
        "engine_name": "APEX",
        "engine_version": "6.608",
        "engine_update": "20250101",
        "category": "type-unsupported",
        "result": null
      },
      "Paloalto": {
        "method": "blacklist",
        "engine_name": "Paloalto",
        "engine_version": "0.9.0.1003",
        "engine_update": "20250104",
        "category": "type-unsupported",
        "result": null
      },
      "Alibaba": {
        "method": "blacklist",
        "engine_name": "Alibaba",
        "engine_version": "0.3.0.5",
        "engine_update": "20190527",
        "category": "type-unsupported",
        "result": null
      },
      "Webroot": {
        "method": "blacklist",
        "engine_name": "Webroot",
        "engine_version": "1.9.0.8",
        "engine_update": "20240910",
        "category": "type-unsupported",
        "result": null
      },
      "Cylance": {
        "method": "blacklist",
        "engine_name": "Cylance",
        "engine_version": "3.0.0.0",
        "engine_update": "20241219",
        "category": "type-unsupported",
        "result": null
      },
      "SentinelOne": {
        "method": "blacklist",
        "engine_name": "SentinelOne",
        "engine_version": "24.2.1.1",
        "engine_update": "20240417",
        "category": "type-unsupported",
        "result": null
      },
      "tehtris": {
        "method": "blacklist",
        "engine_name": "tehtris",
        "engine_version": null,
        "engine_update": "20250104",
        "category": "type-unsupported",
        "result": null
      },
      "Trustlook": {
        "method": "blacklist",
        "engine_name": "Trustlook",
        "engine_version": "1.0",
        "engine_update": "20250104",
        "category": "type-unsupported",
        "result": null
      }
    },
    "deletedDate": "2025-01-05T11:22:41.717Z"
  }
]